import Banner from '@/assets/banner/background.webp';
import PageBannerProduk from '@/components/banner/PageBannerProduk';
import { ContainerFluid } from '@/components/container/Container';
import ProdukSidebar from '@/components/ProdukSidebar';
import Seo from '@/components/seo/Seo';
import DetailSkeletonTwoColumn from '@/components/skeleton/DetailSkeletonTwoColumn';
import { BodySmHTML, H4 } from '@/components/ui/typography/Typography';
import { ApiService } from '@/services/api.services';
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

export default function ProductServiceDetail() {
  const { slug, item: itemSlug } = useParams();

  const [detail, setDetail] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchService = async () => {
      try {
        setLoading(true);
        const res = await ApiService.getServiceBySlug(slug);
        const data = res.data;

        const sortedItems = data.items
          .filter((i) => i.is_active)
          .sort((a, b) => a.position - b.position);

        setDetail(data);
        setItems(sortedItems);
      } catch {
        setDetail(null);
      } finally {
        setLoading(false);
      }
    };

    if (slug) fetchService();
  }, [slug]);

  if (loading) {
    return (
      <>
        <PageBannerProduk item={items} image={Banner} loading={loading} />
        <DetailSkeletonTwoColumn />
      </>
    );
  }
  if (!detail) return <Navigate to="/404" replace />;
  const title = `${detail.title} | Produk Layanan Abdi Kerta Raharja`;
  const description =
    detail.meta_description || detail.description?.replace(/<[^>]+>/g, '').slice(0, 155);

  const canonical = itemSlug
    ? `https://www.abdikertaraharja.co.id/produk-layanan/${slug}/${itemSlug}`
    : `https://www.abdikertaraharja.co.id/produk-layanan/${slug}`;
  return (
    <>
      <Seo title={title} description={description} canonical={canonical} />
      <div>
        <PageBannerProduk item={detail} image={Banner} loading={loading} />

        <ContainerFluid className="py-8 lg:py-16">
          <div className="flex flex-col-reverse lg:flex-row gap-10">
            <ProdukSidebar
              title={detail.title}
              items={items}
              basePath={`/produk-layanan/${slug}`}
            />

            <div className="flex-1">
              {itemSlug ? (
                <Outlet context={detail} />
              ) : (
                <div>
                  <H4>{detail.title}</H4>
                  <BodySmHTML content={detail.description} className={'py-2'} />
                </div>
              )}
            </div>
          </div>
        </ContainerFluid>
      </div>
    </>
  );
}
